import { render, staticRenderFns } from "./switch-user.vue?vue&type=template&id=547cd544&scoped=true"
import script from "./switch-user.vue?vue&type=script&lang=js"
export * from "./switch-user.vue?vue&type=script&lang=js"
import style0 from "./switch-user.vue?vue&type=style&index=0&id=547cd544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547cd544",
  null
  
)

export default component.exports